import { render, staticRenderFns } from "./OverlayWindow.vue?vue&type=template&id=c8691078&scoped=true&"
import script from "./OverlayWindow.vue?vue&type=script&lang=ts&"
export * from "./OverlayWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8691078",
  null
  
)

export default component.exports